function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import { format, nextMonday } from 'date-fns';
import { useEffect, useState } from 'react';
import { Box, Button, ButtonLink, Card, Divider, Flex, GridAlpha, Heading, HelpText, Select, Spinner, Text, useToasts } from '@applyboard/crystal-ui';
import { ChevronRightOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
import { useAgency } from "../../data";
import { BucketType, DeliveryChannelType, FrequencyType, useCreateNotificationPolicy, useNotificationPolicies, usePatchNotificationPolicy } from "../../data/notificationsPolicies";
import { WhatsAppOptInDialog } from "../WhatsAppOptInDialog/WhatsAppOptInDialog";
import { CcOnStaffCommunicationsSwitch } from "./CcOnStaffCommunicationsSwitch";
import ChatImage from "./chat.svg";
import MobileApplicationImage from "./phone.svg";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var FREQUENCY = {
  IMMEDIATE: 'Immediate',
  DAILY: 'Daily',
  WEEKLY: 'Weekly'
};
var NOTIFICATION_BUCKET_TYPE = {
  APPLICATION_NOTES: 'Application notes'
};
var DELIVERY_CHANNEL = {
  EMAIL: {
    type: 'email',
    header: 'Email notifications'
  },
  WHATSAPP: {
    type: 'whatsapp',
    header: 'Whatsapp notifications'
  }
};
var frequencyOptions = [{
  label: 'Immediate',
  value: 'IMMEDIATE'
}, {
  label: getNextDailyScheduledEmailTimeLabel(),
  value: 'DAILY'
}, {
  label: getNextWeeklyScheduledEmailTimeLabel(),
  value: 'WEEKLY'
}];
function ActionPromptCard(_ref) {
  var title = _ref.title,
    imageProps = _ref.imageProps,
    description = _ref.description,
    buttonProps = _ref.buttonProps;
  return _jsx(Card, {
    children: _jsxs(Flex, {
      gap: 10,
      direction: "column",
      justify: "center",
      align: "center",
      children: [_jsx(Flex.Item, {
        align: "start",
        children: _jsx(Card.Header, {
          children: _jsx(Heading, {
            variant: "titleM",
            level: 4,
            children: title
          })
        })
      }), _jsx("div", {
        style: {
          maxWidth: '146px',
          maxHeight: '140px'
        },
        children: _jsx(Card.Image, {
          src: imageProps.src,
          alt: ""
        })
      }), _jsx(Flex, {
        gap: 5,
        direction: "column",
        children: _jsx(HelpText, {
          children: description
        })
      }), buttonProps.promptLink ? _jsx(ButtonLink, {
        intent: "primary",
        href: buttonProps.promptLink,
        mode: "override_user_choice_and_open_in_new_tab",
        onClick: buttonProps.onClick,
        children: buttonProps.text
      }) : _jsx(Button, {
        intent: "primary",
        onClick: buttonProps.onClick,
        children: buttonProps.text
      })]
    })
  });
}
function MobilePushNotificationCard() {
  return _jsx(ActionPromptCard, {
    title: "Mobile push notifications",
    description: "To receive your notifications via mobile, go to your ApplyBoard app. Don't have the\napp?",
    imageProps: {
      src: MobileApplicationImage,
      alt: 'ApplyBoard Mobile Application'
    },
    buttonProps: {
      text: 'Download app',
      promptLink: 'https://www.applyboard.com/downloadapp'
    }
  });
}
function WhatsAppCard(_ref2) {
  var openWhatsAppOptInDialog = _ref2.openWhatsAppOptInDialog,
    isWhatsAppVerified = _ref2.isWhatsAppVerified,
    whatsAppNotificationPolicy = _ref2.whatsAppNotificationPolicy,
    whatsAppContactInfo = _ref2.whatsAppContactInfo;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var showNotificationCard = isWhatsAppVerified && whatsAppNotificationPolicy && whatsAppContactInfo;
  if (showNotificationCard) {
    return _jsx(NotificationCard, {
      notificationPolicyId: whatsAppNotificationPolicy.notificationPolicyId,
      frequency: whatsAppNotificationPolicy.frequency,
      deliveryChannelType: "WHATSAPP",
      frequencyOptionsPrompt: _jsxs(HelpText, {
        children: ["Select to receive your notifications via WhatsApp text messages at ", whatsAppContactInfo, ".", _jsx("br", {}), _jsxs(Flex, {
          align: "center",
          gap: 2,
          children: ["Wrong number?", _jsx(Button, {
            emphasis: "transparent",
            intent: "primary",
            onClick: openWhatsAppOptInDialog,
            children: "Change it"
          })]
        })]
      })
    });
  }
  return _jsx(ActionPromptCard, {
    title: "WhatsApp notifications",
    description: "To receive your notifications via WhatsApp text messages, please add and verify a phone number.",
    imageProps: {
      src: ChatImage
    },
    buttonProps: {
      text: 'Add WhatsApp number',
      onClick: function onClick() {
        trackEvent({
          event: 'Notification Preferences - Clicked Add WhatsApp Number'
        });
        openWhatsAppOptInDialog();
      }
    }
  });
}
function NotificationCard(_ref3) {
  var deliveryChannelType = _ref3.deliveryChannelType,
    notificationPolicyId = _ref3.notificationPolicyId,
    frequency = _ref3.frequency,
    frequencyOptionsPrompt = _ref3.frequencyOptionsPrompt;
  var _useState = useState(frequency),
    _useState2 = _slicedToArray(_useState, 2),
    deliveryFrequency = _useState2[0],
    setDeliveryFrequency = _useState2[1];
  var toasts = useToasts();
  var selectedDeliveryChannel = DELIVERY_CHANNEL[deliveryChannelType];
  var _usePatchNotification = usePatchNotificationPolicy(),
    patchChangeRequest = _usePatchNotification.patchChangeRequest;
  var handleOnChangeNotificationFrequency = function handleOnChangeNotificationFrequency(frequency) {
    patchChangeRequest({
      notification_policy_id: notificationPolicyId,
      requestBody: {
        frequency: frequency
      }
    }, {
      onSuccess: function onSuccess() {
        setDeliveryFrequency(frequency);
        toasts.positive('Notification preference updated successfully!');
      },
      onError: function onError() {
        return toasts.negative(new Error('An error occurred, try again later'));
      }
    });
  };
  return _jsx(Card, {
    children: _jsxs(Flex, {
      gap: 10,
      direction: "column",
      children: [_jsx(Card.Header, {
        children: _jsx(Heading, {
          variant: "titleM",
          level: 4,
          children: selectedDeliveryChannel.header
        })
      }), _jsxs(Flex, {
        gap: 5,
        direction: "column",
        children: [frequencyOptionsPrompt, _jsx(Select, {
          appearance: "styled",
          label: "Frequency options",
          "aria-label": "Frequency options",
          onChange: handleOnChangeNotificationFrequency,
          value: deliveryFrequency,
          placeholder: "",
          children: frequencyOptions.map(function (_ref4) {
            var label = _ref4.label,
              value = _ref4.value;
            return _jsx(Select.Option, {
              label: label,
              value: value
            }, label);
          })
        }), _jsx(HelpText, {
          children: "Set your notification delivery frequency."
        })]
      })]
    })
  });
}
var SpinnerComponent = function SpinnerComponent() {
  return _jsx(Flex, {
    align: "center",
    direction: "column",
    py: 24,
    children: _jsx(Spinner, {
      size: "xl"
    })
  });
};
export var NotificationsPreferences = function NotificationsPreferences(_ref5) {
  var _agency$data;
  var agencyId = _ref5.agencyId,
    showWhatsAppNotificationCard = _ref5.showWhatsAppNotificationCard;
  var toasts = useToasts();
  var _useState3 = useState('APPLICATION_NOTES'),
    _useState4 = _slicedToArray(_useState3, 2),
    notificationBucketType = _useState4[0],
    setNotificationBucketType = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    openWhatsAppDialogModal = _useState6[0],
    setOpenWhatsAppDialogModal = _useState6[1];
  var _useNotificationPolic = useNotificationPolicies(),
    refetchNotificationPolicies = _useNotificationPolic.refetchNotificationPolicies,
    notificationPolicies = _useNotificationPolic.notificationPolicies,
    isFetchingNotificationPoliciesSuccess = _useNotificationPolic.isFetchingNotificationPoliciesSuccess,
    isFetchingNotificationPoliciesLoading = _useNotificationPolic.isFetchingNotificationPoliciesLoading;
  var _useCreateNotificatio = useCreateNotificationPolicy(),
    createNotificationPolicy = _useCreateNotificatio.createNotificationPolicy,
    isCreateNotificationPolicyLoading = _useCreateNotificatio.isCreateNotificationPolicyLoading;
  var rpHasNoNotificationPolicyCreated = isFetchingNotificationPoliciesSuccess && Array.isArray(notificationPolicies) && notificationPolicies.length === 0;
  var _useAgency = useAgency(agencyId),
    agency = _useAgency.agency,
    isFetchAgencySuccessful = _useAgency.isFetchAgencySuccessful,
    isLoadingAgency = _useAgency.isLoadingAgency,
    refetchAgency = _useAgency.refetchAgency;
  useEffect(function () {
    if (rpHasNoNotificationPolicyCreated) {
      createNotificationPolicy({
        bucket: BucketType.APPLICATION_NOTES,
        delivery_channel: DeliveryChannelType.EMAIL,
        frequency: FrequencyType.IMMEDIATE,
        cc_on_staff_communications: false
      }, {
        onError: function onError() {
          toasts.negative(new Error('An error occurred, try again later'));
        },
        onSettled: function () {
          var _onSettled = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  refetchNotificationPolicies();
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function onSettled() {
            return _onSettled.apply(this, arguments);
          }
          return onSettled;
        }()
      });
    }
  }, [rpHasNoNotificationPolicyCreated, createNotificationPolicy, refetchNotificationPolicies, toasts]);
  var createWhatsAppNotificationPolicy = function createWhatsAppNotificationPolicy() {
    createNotificationPolicy({
      bucket: BucketType.APPLICATION_NOTES,
      delivery_channel: DeliveryChannelType.WHATSAPP,
      frequency: FrequencyType.IMMEDIATE,
      cc_on_staff_communications: false
    }, {
      onSettled: function () {
        var _onSettled2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return refetchNotificationPolicies();
              case 2:
                _context2.next = 4;
                return refetchAgency();
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function onSettled() {
          return _onSettled2.apply(this, arguments);
        }
        return onSettled;
      }()
    });
  };
  if (isFetchingNotificationPoliciesLoading || isCreateNotificationPolicyLoading || isLoadingAgency) return _jsx(SpinnerComponent, {});
  var notificationPolicyEmailType = notificationPolicies === null || notificationPolicies === void 0 ? void 0 : notificationPolicies.find(function (policy) {
    return policy.deliveryChannel === 'EMAIL';
  });
  if (!notificationPolicyEmailType) return _jsx(SpinnerComponent, {});
  var notificationPolicyIdEmailType = notificationPolicyEmailType === null || notificationPolicyEmailType === void 0 ? void 0 : notificationPolicyEmailType.notificationPolicyId;
  var notificationPolicyFrequencyEmailType = notificationPolicyEmailType === null || notificationPolicyEmailType === void 0 ? void 0 : notificationPolicyEmailType.frequency;
  var whatsAppNotificationPolicy = notificationPolicies === null || notificationPolicies === void 0 ? void 0 : notificationPolicies.find(function (policy) {
    return policy.deliveryChannel === 'WHATSAPP';
  });
  var isWhatsAppVerified = !!(agency !== null && agency !== void 0 && (_agency$data = agency.data) !== null && _agency$data !== void 0 && _agency$data.whatsappVerifiedAt);
  var showWhatsAppCard = showWhatsAppNotificationCard && isFetchAgencySuccessful && agency;
  return _jsxs(_Fragment, {
    children: [_jsx(WhatsAppOptInDialog, {
      setIsOpen: setOpenWhatsAppDialogModal,
      isOpen: openWhatsAppDialogModal,
      overrideInitialState: isWhatsAppVerified ? 'phoneNumberChange' : 'initial',
      agentInformationId: "".concat(agencyId),
      onSuccessfulOptin: createWhatsAppNotificationPolicy
    }), _jsxs(Box, {
      p: 4,
      children: [_jsx(Heading, {
        variant: "titleL",
        level: 1,
        children: _jsxs(Flex, {
          direction: "row",
          justify: "between",
          children: [_jsx(Flex.Item, {
            children: "Notification preferences"
          }), _jsx(Flex.Item, {
            children: _jsx(CcOnStaffCommunicationsSwitch, {})
          })]
        })
      }), _jsx(Divider, {
        direction: "horizontal"
      }), _jsxs(Flex, {
        as: "div",
        gap: 6,
        children: [_jsx(Flex.Item, {
          as: "aside",
          children: _jsx(Box, {
            pt: 8,
            pr: 4,
            children: _jsxs(Flex, {
              direction: "column",
              children: [_jsx(Heading, {
                level: 2,
                variant: "titleM",
                children: "Notification type"
              }), _jsx(Divider, {
                direction: "horizontal"
              }), _jsxs(Flex, {
                direction: "column",
                gap: 2,
                children: [_jsx(Text, {
                  variant: "labelL",
                  children: "Application"
                }), _jsx(Button, {
                  trailIcon: ChevronRightOutlineIcon,
                  emphasis: "highlighted",
                  intent: "primary",
                  onClick: function onClick() {
                    setNotificationBucketType('APPLICATION_NOTES');
                  },
                  children: NOTIFICATION_BUCKET_TYPE['APPLICATION_NOTES']
                })]
              })]
            })
          })
        }), _jsx(Divider, {
          direction: "vertical"
        }), _jsx(Flex.Item, {
          as: "main",
          grow: 1,
          children: _jsx("div", {
            children: _jsxs(Box, {
              pt: 8,
              pb: 6,
              children: [_jsx(Heading, {
                variant: "titleM",
                level: 3,
                children: NOTIFICATION_BUCKET_TYPE[notificationBucketType]
              }), _jsx(Divider, {
                direction: "horizontal"
              }), _jsxs(GridAlpha, {
                columnGap: 6,
                columns: {
                  xs: 'repeat(1,285px)',
                  sm: 'repeat(2,285px)',
                  lg: 'repeat(3,325px)'
                },
                rowGap: 6,
                children: [_jsx(NotificationCard, {
                  notificationPolicyId: notificationPolicyIdEmailType,
                  frequency: notificationPolicyFrequencyEmailType,
                  deliveryChannelType: "EMAIL",
                  frequencyOptionsPrompt: _jsx(HelpText, {
                    children: "Select your notifications via email."
                  })
                }), showWhatsAppCard ? _jsx(WhatsAppCard, {
                  openWhatsAppOptInDialog: function openWhatsAppOptInDialog() {
                    setOpenWhatsAppDialogModal(true);
                  },
                  isWhatsAppVerified: isWhatsAppVerified,
                  whatsAppNotificationPolicy: whatsAppNotificationPolicy,
                  whatsAppContactInfo: agency.data.whatsappUsername
                }) : _jsx(_Fragment, {}), _jsx(MobilePushNotificationCard, {})]
              })]
            })
          })
        })]
      })]
    })]
  });
};
function getBrowserTimezone() {
  return new Date().toLocaleDateString(undefined, {
    day: '2-digit',
    timeZoneName: 'short'
  }).slice(4);
}
function getNextDailyScheduledEmailTimeLabel() {
  // 9:00 AM (IST)
  var nextDailyScheduledEmail = new Date("".concat(format(new Date(), 'yyyy-MM-dd'), "T03:30:00.000Z"));
  return "Daily at ".concat(format(nextDailyScheduledEmail, 'hh:mm aaa'), " (").concat(getBrowserTimezone(), ")");
}
function getNextWeeklyScheduledEmailTimeLabel() {
  // Next Monday 9:00 AM (IST)
  var nextWeeklyScheduledEmail = new Date(nextMonday(new Date("".concat(format(new Date(), 'yyyy-MM-dd'), "T03:30:00.000Z"))));
  return "Weekly on Mondays at ".concat(format(nextWeeklyScheduledEmail, 'hh:mm aaa'), " (").concat(getBrowserTimezone(), ")");
}